import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
  getMyWorksToDo: {
    apiServiceMethodName:
      ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_DO].GET_MY_WORKS_TO_DO
  },
}